/**
 * Web version of storefront detector
 * On web, there are no storefront restrictions, so we always return true
 */
export async function getIsStorefrontSupported(): Promise<boolean> {
  return true
}
